type createCookieProps = {
  name: string;
  value: boolean;
  time?: string;
};

const createCookie = ({ name, value, time }: createCookieProps) => {
  let expires;
  if (time) {
    const date = new Date();
    date.setTime(date.getTime() + parseInt(time, 10) * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value}${expires}; path=/;`;
};

const getCookieByKey = (name: string) => {
  return document.cookie
    .split(';')
    .filter((cookie) => new RegExp(name).test(cookie))
    .map((cookie) => cookie.split('=')[1])[0];
};

export { createCookie, getCookieByKey };
